import React from 'react';

const services = [
  { title: 'سایت با کدنویسی اختصاصی', desc: 'کدنویسی بهینه و اختصاصی برای کسب‌وکار شما' },
  { title: 'گرافیک و طراحی اختصاصی', desc: 'طراحی منحصر به فرد و هماهنگ با برند' },
  { title: 'سرعت و بهینه‌سازی', desc: 'بارگذاری سریع و تجربه کاربری بهتر' },
  { title: 'سئو و رتبه‌گیری', desc: 'بهینه‌سازی برای موتورهای جستجو' },
  { title: 'امنیت و استانداردها', desc: 'پیاده‌سازی استانداردهای امنیتی روز' },
  { title: 'نسخه موبایل و ریسپانسیو', desc: 'نمایش بهینه در تمام دستگاه‌ها' },
];

const Services = () => {
  return (
    <section id="services" className="py-16 sm:py-20 bg-slate-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <p className="text-teal-400 text-sm font-medium text-center mb-2">خدمات ما</p>
        <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-4">
          خدمات
        </h2>
        <p className="text-slate-400 text-center max-w-xl mx-auto mb-12">
          مجموعه‌ای از خدمات طراحی و توسعه وب برای رشد کسب‌وکار شما
        </p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((item, i) => (
            <li
              key={i}
              className="group relative bg-slate-800/80 rounded-xl p-6 border border-slate-700/50 shadow-lg hover:shadow-xl hover:shadow-teal-500/10 hover:border-teal-500/30 hover:-translate-y-2 transition-all duration-300 overflow-hidden"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              {/* Animated gradient background */}
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/0 via-teal-500/0 to-cyan-500/0 group-hover:from-teal-500/10 group-hover:via-teal-500/5 group-hover:to-cyan-500/10 transition-all duration-500 -z-10" />
              
              {/* Animated accent bar */}
              <span className="absolute top-0 right-0 w-1 h-0 group-hover:h-full bg-gradient-to-b from-teal-500 to-teal-400 transition-all duration-500 rounded-l shadow-lg shadow-teal-500/30" />
              
              {/* Number with glow effect */}
              <div className="relative">
                <span className="text-2xl font-bold text-slate-600 group-hover:text-teal-400 text-right block mb-2 transition-colors duration-300">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="absolute top-0 right-0 w-8 h-8 bg-teal-400/30 rounded-full blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              
              {/* Content */}
              <h3 className="font-semibold text-white group-hover:text-teal-400 transition-colors relative z-10">
                {item.title}
              </h3>
              <p className="text-slate-400 text-sm mt-1.5 leading-relaxed relative z-10">{item.desc}</p>
              
              {/* Decorative corner */}
              <div className="absolute bottom-0 left-0 w-12 h-12 border-l-2 border-b-2 border-teal-500/0 group-hover:border-teal-500/50 rounded-br-xl transition-colors duration-300" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Services;
